"use client";

import { Icon, ospThemes } from "@ospweb/sdk-ui";

import React from "react";
import { cn } from "utils";
import { useCheckAccessClick } from "@/src/hooks/useCheckAccessClick";
import { overlapAttributionDataProps } from "@features/etf-overlap/tracking/overlapAttribution";

/** `data-or-param-title` 过长会撑大 payload（软上限 8 KB，规范 §3），截到 80 字符 */
const OVERLAP_TITLE_MAX = 80;

interface RelatedPropsType {
  question: string;
  onSendRelatedValue?: (inputString: string) => void;
  className?: string;
  /**
   * 仅重叠分析结果消息传入：该问题在列表里的位置（0 起）。
   * 相关问题由 AI 生成、没有稳定 id，所以只带 `position` + `title`（EDG-561 `overlap_followup_tap`）。
   */
  overlapPosition?: number;
}
function RelatedItem({
  question,
  onSendRelatedValue,
  className,
  overlapPosition,
}: RelatedPropsType) {
  const { handleAccessClick } = useCheckAccessClick({
    originClick: () => {
      onSendRelatedValue?.(question);
    },
  });
  return (
    <div
      data-openreplay-label="chatbox_relateditemquestion_click"
      className={cn(
        "rounded-lg py-2 px-3 bg-background_solid_tertiary hover:bg-background_white_overlay10 flex flex-row flex-1 items-center cursor-pointer w-[fit-content] rounded-[8px]",
        "md:flex-1 flex-shrink-0 flex-grow-0 rounded-[8px]",
        className,
      )}
      id="related-card"
      onClick={handleAccessClick}
      role="button"
      aria-label={`RelatedItem question: ${question}`}
      tabIndex={0}
      {...(overlapPosition !== undefined
        ? {
            "data-or-event": "overlap_followup_tap",
            "data-or-param-position": String(overlapPosition),
            "data-or-param-title": question.slice(0, OVERLAP_TITLE_MAX),
            ...overlapAttributionDataProps(),
          }
        : {})}
    >
      <div className="mr-1 body_m text-content_secondary">{question}</div>
      <Icon
        name="arrow-right"
        color={ospThemes.colors.content_secondary}
        aria-hidden="true"
      />
    </div>
  );
}

export default React.memo(RelatedItem);
